// BlogTile.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./BlogTile.css";

const BlogTile = ({ blog }) => {
  return (
    <article className="blog-tile">
      <div className="blog-tile-image">
        <img src={blog.image} alt={blog.title} />
      </div>
      <div className="blog-tile-content">
        <div className="blog-tile-tags">
          {blog.tags.map((tag, index) => (
            <span key={index} className="blog-tag">
              {tag}
            </span>
          ))}
        </div>
        <Link to={`/blog/${blog.slug}`} className="blog-tile-title">
          <h2>{blog.title}</h2>
        </Link>
        <div className="blog-tile-meta">
          {blog.authorImage && (
            <img
              src={blog.authorImage}
              alt={blog.author}
              className="author-image"
            />
          )}
          <div className="blog-tile-info">
            {blog.author && <span className="blog-author">{blog.author}</span>}
            <time className="blog-date">{blog.publishDate}</time>
          </div>
        </div>
        <p className="blog-tile-excerpt">{blog.excerpt}</p>
      </div>
    </article>
  );
};

export default BlogTile;
